<template>
  <fragment>
    <div class="dropdown-w" v-if="campaignsPageData">
      <b-select expanded :placeholder="$t('Campaigns.Type.Title')" v-model="campaignsPageData.IsMediaChannel" @input="onCampaignTypeChange">
        <option :value="false">
          {{ $t("Campaigns.Type.Paid") }}
        </option>
        <option :value="true">
          {{ $t("Campaigns.Type.Media") }}
        </option>
      </b-select>
    </div>

    <div class="dropdown-w" v-show="campaignsPageData && !campaignsPageData.CompanyId">
      <b-dropdown :value="selectedCompaniesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!companies.length"
            @active-change="onDropdownActiveChange" @change="onCompanyChange($event)">
        <template #trigger>
          <b-button>
            <span class="dropdown-trigger-value">{{ $t("Campaigns.CompanyPlaceholder") }} ({{ selectedCompaniesIds.length }})</span>
            <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
          </b-button>
        </template>
        <b-dropdown-item custom aria-role="listitem" class="filter-search">
          <b-input v-model="companiesSearch" class="search" :placeholder="$t('Search')" expanded />
        </b-dropdown-item>
        <b-dropdown-item v-for="company in companiesFiltered" :key="company.Id" :value="company.Id" aria-role="listitem">
          <b-checkbox size="is-small" :value="isCompanySelected(company.Id)" disabled></b-checkbox>
          <span>{{ company.Title }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="dropdown-w" v-if="campaignsPageData">
      <b-dropdown :value="selectedCampaignStatus" aria-role="list" class="custom-checkboxes"
            @active-change="onDropdownActiveChange" @change="onCampaignStatusChange($event)">
        <template #trigger>
          <b-button>
            <span class="dropdown-trigger-value">{{ selectedStatusString }}</span>
            <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
          </b-button>
        </template>
        <b-dropdown-item aria-role="listitem" class="is-icon" :value="1">
          <template>
            <span class="indicator indicator-1"></span>
            <span class="label">{{ $t("Campaigns.Status.Active") }}</span>
          </template>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" class="is-icon" :value="0">
          <template>
            <span class="indicator indicator-4"></span>
            <span class="label">{{ $t("Campaigns.Status.NotActive") }}</span>
          </template>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" class="is-icon" :value="2" v-if="!campaignsPageData.IsMediaChannel">
          <template>
            <span class="indicator indicator-5"></span>
            <span class="label">{{ $t("Campaigns.Status.TokenInvalid") }}</span>
          </template>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" class="is-icon" :value="3" v-if="!campaignsPageData.IsMediaChannel">
          <template>
            <span class="indicator indicator-3"></span>
            <span class="label">{{ $t("Campaigns.Status.NotConnected") }}</span>
          </template>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" class="is-icon" :value="4" v-if="!campaignsPageData.IsMediaChannel">
          <template>
            <span class="indicator indicator-2"></span>
            <span class="label">{{ $t("Campaigns.Status.MissingPermission") }}</span>
          </template>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" class="is-icon" :value="null" v-if="!campaignsPageData.IsMediaChannel">
          <template>
            <span class="label">{{ $t("All") }}</span>
          </template>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="dropdown-w">
      <b-dropdown :value="selectedChannelMetadataTypesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
            @active-change="onDropdownActiveChange" @change="onChannelMetadataTypesChange($event)">
        <template #trigger>
          <b-button>
            <span class="dropdown-trigger-value">{{ $t("Leads.ChannelMetadataPlaceholder") }} ({{ selectedChannelMetadataTypesIds.length }})</span>
            <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
          </b-button>
        </template>
        <b-dropdown-item custom aria-role="listitem" class="filter-search">
          <b-input v-model="channelMetadataTypesSearch" class="search" :placeholder="$t('Search')" expanded />
        </b-dropdown-item>
        <b-dropdown-item v-for="channelMetadataType in channelMetadataTypesFiltered" :key="+channelMetadataType.Id" :value="+channelMetadataType.Id"
              aria-role="listitem" class="dropdown-item-with-icon">
          <b-checkbox size="is-small" :value="isChannelMetadataTypeSelected(+channelMetadataType.Id)" disabled></b-checkbox>
          <span class="icon-w" v-if="getChannelMetadataTypeIconName(channelMetadataType.Id)">
            <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channelMetadataType.Id) + '.png')" />
          </span>
          <span class="text">{{ channelMetadataType.Title }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="dropdown-w">
      <b-dropdown :value="selectedProjectsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!projects.length"
            @active-change="onDropdownActiveChange" @change="onProjectsChange($event)">
        <template #trigger>
          <b-button>
            <span class="dropdown-trigger-value">{{ $t("Leads.ProjectPerformancePlaceholder") }} ({{ selectedProjectsIds.length }})</span>
            <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
          </b-button>
        </template>
        <b-dropdown-item custom aria-role="listitem" class="filter-search">
          <b-input v-model="projectsSearch" class="search" :placeholder="$t('Search')" expanded />
        </b-dropdown-item>
        <b-dropdown-item v-for="project in projectsFiltered" :key="project.Id" :value="project.Id" aria-role="listitem">
          <b-checkbox size="is-small" :value="isProjectSelected(project.Id)" disabled></b-checkbox>
          <span>{{ project.Title }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </fragment>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import VueCookies from "vue-cookies";
import Fragment from "vue-fragment";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import { Action, Getter } from "vuex-class";
import { MultiselectItem } from "@/models/MultiselectItem";
import HelperService from "@/services/HelperService";
import { CommonMultiselectPayload } from "@/services/api/ApiService";
import { CampaignStatus } from "@/models/campaigns/CampaignStatus";
import i18n from "@/i18n";
import CampaignService from "@/services/CampaignService";
import { AvailableChannelMetadataTypesMode, ChannelType } from "@/models/campaigns/ChannelType";
import { CampaignsPageViewModel } from "@/models/campaigns/Campaign";
import { RefreshGridMode } from "@/models/campaigns/CampaignGridView";

Vue.use(Fragment.Plugin);
Vue.use(VueCookies);
const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
  },
})
export default class CampaignsFiltersDropdowns extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignsPageData", { namespace }) campaignsPageData!: CampaignsPageViewModel;
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("isMediaChannel", { namespace }) isMediaChannel!: boolean;
  @Getter("projects", { namespace }) projects!: MultiselectItem[];
  @Getter("selectedCampaignsIds", { namespace }) selectedCampaignsIds!: number[];
  @Getter("selectedCampaignStatus", { namespace }) selectedCampaignStatus!: CampaignStatus | null;
  @Getter("selectedChannelMetadataTypesIds", { namespace }) selectedChannelMetadataTypesIds!: number[];
  @Getter("selectedCompaniesIds", { namespace }) selectedCompaniesIds!: number[];
  @Getter("selectedProjectsIds", { namespace }) selectedProjectsIds!: number[];
  @Action("getProjects", { namespace }) getProjects!: (payload: CommonMultiselectPayload) => Promise<MultiselectItem[]>;
  @Action("setIsMediaChannel", { namespace }) setIsMediaChannel!: (isMediaChannel: boolean) => void;
  @Action("setNeedToRefreshCampaignsGrid", { namespace }) setNeedToRefreshCampaignsGrid!: (needToRefreshCampaignsGrid: RefreshGridMode) => void;
  @Action("setSelectedCampaignStatus", { namespace }) setSelectedCampaignStatus!: (selectedCampaignStatus?: CampaignStatus) => void;
  @Action("setSelectedChannelMetadataTypesIds", { namespace }) setSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setSelectedCompaniesIds", { namespace }) setSelectedCompaniesIds!: (selectedCompaniesIds: number[]) => void;
  @Action("setSelectedProjectsIds", { namespace }) setSelectedProjectsIds!: (selectedProjectsIds: number[]) => void;

  //#endregion Vuex getters and actions


  //#region Properties

  channelMetadataTypesSearch = "";
  companiesSearch = "";
  projectsSearch = "";

  //#endregion Properties


  //#region Watchers

  @Watch("selectedCampaignsIds", { immediate: true })
  onSelectedCampaignsIdsChange(newSelectedCampaignsIds: number[], oldSelectedCampaignsIds: number[]): void {
    if (oldSelectedCampaignsIds === undefined) {
      return;
    } else {
      this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedCampaignStatus", { immediate: true })
  onSelectedCampaignStatusChange(newSelectedCampaignStatus: CampaignStatus | null, oldSelectedCampaignStatus: CampaignStatus | null): void {
    if (oldSelectedCampaignStatus === undefined || newSelectedCampaignStatus === oldSelectedCampaignStatus) {
      return;
    } else {
      this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedChannelMetadataTypesIds", { immediate: true })
  onSelectedChannelMetadataTypesIdsChange(newSelectedChannelMetadataTypesIds: number[], oldSelectedChannelMetadataTypesIds: number[]): void {
    if (oldSelectedChannelMetadataTypesIds === undefined || newSelectedChannelMetadataTypesIds.length === oldSelectedChannelMetadataTypesIds.length) {
      return;
    } else {
      this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedCompaniesIds", { immediate: true })
  onSelectedCompaniesIdsChange(newSelectedCompaniesIds: number[], oldSelectedCompaniesIds: number[]): void {
    if (oldSelectedCompaniesIds === undefined) {
      return;
    } else {
      this.setSelectedProjectsIds([]);
      this.getProjects(this.commonPayload);
      this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedProjectsIds", { immediate: true })
  onSelectedProjectsIdsChange(newSelectedProjectsIds: number[], oldSelectedProjectsIds: number[]): void {
    if (oldSelectedProjectsIds === undefined || newSelectedProjectsIds.length === oldSelectedProjectsIds.length) {
      return;
    } else {
      this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
    }
  }

  //#endregion Watchers


  //#region Getters

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    const mode: AvailableChannelMetadataTypesMode = this.isMediaChannel ? AvailableChannelMetadataTypesMode.MediaCampaigns : AvailableChannelMetadataTypesMode.Campaigns;
    return CampaignService.getChannelMetadataTypes(mode, this.channelMetadataTypesSearch.toLowerCase())
      .sort(HelperService.sortMultiselectItemsByIds(this.selectedChannelMetadataTypesIds));
  }

  get companiesFiltered(): MultiselectItem[] {
    return this.companies.filter((i: MultiselectItem) => i.Title.toLowerCase().indexOf(this.companiesSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.selectedCompaniesIds));
  }

  get commonPayload(): CommonMultiselectPayload {
    return {
      companyIds: this.selectedCompaniesIds,
      showNotActiveCamp: false,
      metadataIds: this.selectedChannelMetadataTypesIds,
      statusIds: [],
      channelIds: [],
    };
  }

  get projectsFiltered(): MultiselectItem[] {
    return this.projects.filter((i: MultiselectItem) => i.Title.toLowerCase().indexOf(this.projectsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.selectedProjectsIds));
  }

  get selectedStatusString(): string {
    if (this.selectedCampaignStatus === null) {
      return i18n.t("All").toString();
    }
    switch (this.selectedCampaignStatus) {
      case CampaignStatus.Active:
        return i18n.t("Campaigns.Status.Active").toString();
      case CampaignStatus.MissingPermission:
        return i18n.t("Campaigns.Status.MissingPermission").toString();
      case CampaignStatus.NotActive:
        return i18n.t("Campaigns.Status.NotActive").toString();
      case CampaignStatus.NotConnected:
        return i18n.t("Campaigns.Status.NotConnected").toString();
      case CampaignStatus.TokenInvalid:
        return i18n.t("Campaigns.Status.TokenInvalid").toString();
    }
  }

  //#endregion Getters


  //#region Handlers

  onCampaignStatusChange(campaignStatus?: CampaignStatus): void {
    this.setSelectedCampaignStatus(campaignStatus);
    this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
  }

  onCampaignTypeChange(): void {
    this.setIsMediaChannel(this.campaignsPageData.IsMediaChannel);
    if (this.campaignsPageData.IsMediaChannel && (this.selectedCampaignStatus === null ||
          [CampaignStatus.Active, CampaignStatus.NotActive].indexOf(this.selectedCampaignStatus) === -1)) {
      this.setSelectedCampaignStatus(CampaignStatus.Active);
    }
    this.setSelectedChannelMetadataTypesIds([]);
    this.setNeedToRefreshCampaignsGrid(RefreshGridMode.Full);
  }

  onChannelMetadataTypesChange(channelMetadataTypes: ChannelType[]): void {
    this.setSelectedChannelMetadataTypesIds(channelMetadataTypes);
  }

  onCompanyChange(companyIds: number[]): void {
    this.setSelectedCompaniesIds(companyIds);
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onProjectsChange(projectsIds: number[]): void {
    this.setSelectedProjectsIds(projectsIds);
  }

  //#endregion Handlers


  //#region Private methods

  private getChannelMetadataTypeIconName(type: string): string {
    return CampaignService.getChannelMetadataTypeIconName(+type);
  }

  //#region Is item selected

  private isChannelMetadataTypeSelected(channelMetadataTypeId: number) {
    return this.selectedChannelMetadataTypesIds.includes(channelMetadataTypeId);
  }

  private isCompanySelected(companiesId: number) {
    return this.selectedCompaniesIds.includes(companiesId);
  }

  private isProjectSelected(projectId: number) {
    return this.selectedProjectsIds.includes(projectId);
  }

  //#endregion Is item selected

  //#endregion Private methods
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.dropdown-w {
  padding: 0 12px 20px;
  width: 15%;
  flex: 0 0 15%;
  @media (max-width: 1599px) {
    width: 33.3333%;
    flex: 0 0 33.3333%;
    @media (resolution: 120dpi) {
      width: 15%;
      flex: 0 0 15%;
    }
  }
  @media (max-width: 1279px) and (resolution: 120dpi) {
    width: 33.3333%;
    flex: 0 0 33.3333%;
  }
  @media (max-width: 991px) {
    width: 50%;
    flex: 0 0 50%;
    padding: 0 8px 15px;
  }
  
  .dropdown {
    width: 100%;

    .dropdown-item-with-icon {
      display: flex;

      .icon-w {
        display: flex;
        margin-inline-end: 0.5rem;
        min-width: 22px;

        img {
          max-height: 22px;
          min-width: 22px;
          width: 22px;
        }
      }
    }

    .dropdown-trigger {
      width: 100%;
      .button {
        width: 100%;
      }
    }
  }
}

.indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 1.5px solid #aaa;
  margin-left: 5px;
  display: block;
  &.indicator-1 {
    background-color: $success;
  }
  &.indicator-2 {
    border-color: $success;
  }
  &.indicator-3 {
    border-color: $danger;
  }
  &.indicator-4 {
    background: $lightd;
    border-color: $lightd;
  }
  &.indicator-5 {
    background: $danger;
    border-color: $danger;
  }
}

.b-checkbox.checkbox {
  &.is-icon {
    .status {
      display: flex;
      align-items: center;
      .indicator {
        margin-left: 5px;
      }
      .label {
        font-size: 13px;
        font-weight: normal;
      }
    }
  }
}

html[dir="ltr"] {
  .indicator {
    margin: 0 5px 0 0;
  }
  .b-checkbox.checkbox {
    &.is-icon {
      .status {
        .indicator {
          margin: 0 5px 0 0;
        }
      }
    }
  }
}
</style>
